import styled, { css } from 'styled-components';

export const WrapperSubtitle = styled.div`
  ${({ theme }) => css`
    @media (min-width: ${theme.v2.breakpoints.sm}) and (max-width: ${theme.v2.breakpoints.lg}) {
      max-width: 320px;
    }
  `}
`;

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 140%;
    margin: 0px 0px 24px 0px;
  `}
`;
